import { DateTime } from 'luxon'

export function formatUTCYearMonthDate(date: Date) {
  return DateTime.fromJSDate(date).toUTC().toFormat('yyyy-MM-dd')
}
